<!--
  Travel Carbon Estimator
  Copyright (C) 2026  Manuel Leduc

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <http://www.gnu.org/licenses/>.
-->
<script setup lang="ts">
withDefaults(defineProps<{ size?: number; title?: string }>(), {
  size: 32,
  title: 'Travel Carbon Estimator',
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 64 64"
    role="img"
  >
    <title>{{ title }}</title>
    <!-- Leaf body: primary brand color -->
    <path
      d="M52 12 C32 12 16 24 14 44 C13 50 16 52 22 51 C42 49 54 33 54 14 C54 13 53 12 52 12 Z"
      fill="currentColor"
    />
    <!-- Leaf vein -->
    <path
      d="M50 16 C36 26 26 36 18 50"
      stroke="#FFFFFF"
      stroke-width="2"
      stroke-linecap="round"
      fill="none"
      opacity="0.7"
    />
    <!-- Travel route arc -->
    <path
      d="M8 56 Q32 36 60 52"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-dasharray="3 4"
      fill="none"
    />
  </svg>
</template>
